var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from "react";
import { AiFillPlayCircle } from "react-icons/ai";
import classnames from "classnames";
import { MESSAGE_DIRECTION } from "@whatsper/texterchat-common";
import { isSafari } from "../../../../helpers";
import { ReactComponent as PlaceholderSVG } from '../../../../assets/images/placeholders/video_placeholder_300.svg';
import { getFileUrl } from "../../../../store/FilesStore";
import PlayVideoModal from "./PlayVideoModal";
import MessageMarkdown from "../../../Base/Utils/MessageMarkdown/MessageMarkdown";
import SafeHTMLMarkdown from "../../../Base/Utils/SafeHTMLMarkdown";
import Video from "../../../../components/icons/video";
import s from "./VideoMessage.module.scss";
const VideoMessage = ({ media, shareFile, showCaption, direction, renderMessageAsHTML, className, size = 'large' }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState(undefined);
    const [error, setError] = useState(false);
    const videoRef = useRef(null);
    const isMobileApp = window.ReactNativeWebView;
    useEffect(() => {
        getUrl()
            .then((url) => {
            if (!url) {
                console.error('No URL available for video');
                setError(true);
                setLoading(false);
                return;
            }
            console.debug('Raw video URL', url);
            const urlObject = new URL(url, window.location.origin);
            // Show first frame of the video
            urlObject.hash = 't=0.1';
            const newUrl = urlObject.toString();
            console.debug('New video URL', newUrl);
            setUrl(newUrl);
        })
            .catch((error) => {
            console.error('Error getting video URL', error);
            setError(true);
            setLoading(false);
        });
    }, [media]);
    useEffect(() => {
        if (videoRef.current && url) {
            const video = videoRef.current;
            const handleLoadedVideo = () => {
                setLoading(false);
            };
            // Native event listeners are getting called from all environments
            video.addEventListener('loadeddata', handleLoadedVideo);
            video.addEventListener('loadedmetadata', handleLoadedVideo);
            return () => {
                video.removeEventListener('loadeddata', handleLoadedVideo);
                video.removeEventListener('loadedmetadata', handleLoadedVideo);
            };
        }
    }, [url]);
    const getUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        if (media.fileId) {
            if (isSafari() || isMobileApp) {
                return shareFile(media.fileId);
            }
            return getFileUrl(media.fileId);
        }
        else if (media.url) {
            return media.url;
        }
        else {
            console.error('Message have no file ID or URL');
        }
    });
    const onVideoClick = () => {
        if (error)
            return;
        setModalIsOpen(true);
    };
    const onVideoError = (event) => {
        console.error('Video error', event);
        setError(true);
        setLoading(false);
    };
    if (error) {
        return (React.createElement("div", { className: classnames(s["video-message-wrapper"], className, s.error, s.errorState) },
            React.createElement(Video, { className: s.errorIcon }),
            React.createElement("div", null, "Video not available")));
    }
    return (React.createElement("div", { className: classnames(s["video-message-wrapper"], className, {
            [s["video-message-wrapper--loading"]]: loading,
            [s.small]: size === 'small',
            [s.medium]: size === 'medium',
            [s.large]: size === 'large',
        }) },
        React.createElement("div", null,
            React.createElement("video", Object.assign({ onClick: onVideoClick, onError: onVideoError, src: url, ref: videoRef }, ((isSafari() || isMobileApp) && { playsInline: true }), isMobileApp && { muted: true }), url && React.createElement("source", { src: url, type: media.contentType })),
            loading ? (React.createElement("div", { className: s.placeholderContainer },
                React.createElement(PlaceholderSVG, null))) : (React.createElement(AiFillPlayCircle, { className: s["play-button"] }))),
        media.caption && showCaption ? (renderMessageAsHTML ? (React.createElement(SafeHTMLMarkdown, { message: media.caption, attributes: {
                dir: 'auto',
                className: classnames('video-message-caption', 'markup-text-container', {
                    'video-message-caption--incoming': direction === MESSAGE_DIRECTION.IN,
                }),
            } })) : (React.createElement("div", { className: classnames(s['video-message-caption'], {
                [s['video-message-caption--incoming']]: direction === MESSAGE_DIRECTION.IN,
            }) },
            React.createElement(MessageMarkdown, { text: media.caption })))) : null,
        React.createElement(PlayVideoModal, { visible: modalIsOpen, onClose: () => setModalIsOpen(false), url: url || '', type: media.contentType || '' })));
};
export default VideoMessage;
